import { Menu } from "@/api/interfaces/menu";
import { computed, ref } from "vue";
import { getMenu } from "@/api/v1-api";

export const menu = ref<Menu>(null);

export default function useNavigation() {
    const fillSubnav = async () => {
        await getMenu().then((response) => {
            menu.value = response;
        });
    };

    const competitionsName = computed(() => {
        return menu.value?.competitions?.[0]?.name;
    });

    return {
        menu,
        fillSubnav,
        competitionsName,
    };
}
